module.exports = __webpack_public_path__ + "img/lyca.2799e72f.png";